import { css } from "styled-components";
import token from "styled-token";
import { sizeMixin } from "../sizeMixin";
import { InputMixin } from "./InputMixin";
import { SelectMixin } from "./SelectMixin";
import { StyledIcon } from "../../components/Icon/Icon";
import { StyledInput } from "../../components/Input/Input";
import { StyledListbox } from "../../components/Listbox/ControlledListbox";
import { StyledTag } from "../../components/Tag/Tag";
import { StyledTagCloseButton } from "../../components/Tag/TagCloseButton";
import { StyledComboboxAdditional } from "../../components/Combobox/ComboboxAdditional";

var errorCSS = function errorCSS(props) {
  if (!props.error) {
    return "";
  }

  return token({
    borderColor: "Input.borderColorError"
  }, function (tokens) {
    return css(["&&,&&:hover,&&:active,&&:focus-within{border-color:", ";}"], tokens.borderColor);
  })(props);
};

var focusCSS = function focusCSS(props) {
  if (props.disabled) {
    return "";
  }

  return token({
    focusShadow: "shadows.focus",
    backgroundColor: "Input.backgroundColorInteractive"
  }, function (tokens) {
    return css(["&:focus-within{box-shadow:", ";}&:focus-within,&:focus-within ", ",&:active ", "{background-color:", ";}"], tokens.focusShadow, StyledInput, StyledInput, tokens.backgroundColor);
  })(props);
};

var disabledCSS = function disabledCSS(props) {
  if (!props.disabled) {
    return "";
  }

  return css(["", "{opacity:1;cursor:default;}"], StyledTagCloseButton);
};

export var ComboboxInputMixin = function ComboboxInputMixin(props) {
  var appearance = props.appearance,
      disabled = props.disabled,
      expanded = props.expanded,
      isClearable = props.isClearable,
      size = props.size;
  var isSelect = appearance === "select";
  return token({
    borderWidth: "Input.borderWidth",
    chevronWidth: "Select.chevronWidth",
    fontType: "Input.fontType",
    tagMargin: "ComboboxInput.tagMargin",
    tagPadding: "Tag.verticalPadding",
    closeButtonSize: "Tag.closeButtonSize",
    closeButtonMargin: "Tag.targetPadding",
    horizontalSpacing: "Input.horizontalSpacing",
    minInputWidth: "ComboboxInput.minInputWidth"
  }, function (tokens) {
    return css(["", " padding-right:", "px;", " ", " ", " position:relative;display:flex;flex-wrap:wrap;align-items:center;&&{cursor:", ";}", " ", "{border:0;padding:0;box-shadow:none;flex:1 0 ", ";padding-top:", "px;padding-bottom:", "px;opacity:1;}> ", "{position:absolute;right:", "px;top:calc(50% - ", "px);", "{box-shadow:none;}}", "{margin-right:", "px;margin-top:", "px;margin-bottom:", "px;cursor:default;&:last-of-type{margin-right:", "px;}}", " + ", "{margin-left:-", "px;margin-right:", "px;}", "{border:0;}"], isSelect ? SelectMixin(Object.assign({}, props, {
      "aria-expanded": "" + expanded
    })) : InputMixin(props), (isSelect ? tokens.chevronWidth : tokens.horizontalSpacing) + (isClearable ? tokens.closeButtonSize + tokens.closeButtonMargin : 0), focusCSS(props), errorCSS(props), disabledCSS(props), disabled ? "default" : "text", sizeMixin({
      fontType: tokens.fontType,
      borderWidth: tokens.borderWidth * 2 + tokens.tagMargin + tokens.tagPadding * 2,
      size: size
    })(props), StyledInput, tokens.minInputWidth, tokens.tagMargin / 2 + tokens.tagPadding, tokens.tagMargin / 2 + tokens.tagPadding, StyledTagCloseButton, isSelect ? tokens.chevronWidth : tokens.horizontalSpacing, tokens.closeButtonSize / 2, StyledIcon, StyledTag, tokens.tagMargin, tokens.tagMargin / 2, tokens.tagMargin / 2, tokens.horizontalSpacing, StyledTag, StyledComboboxAdditional, tokens.horizontalSpacing - tokens.tagMargin, tokens.horizontalSpacing, StyledListbox);
  })(props);
};